import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { BancoldexService } from "src/app/comun/services/bancoldex.service"
import { VerificacionService } from "src/app/comun/services/verificacion.service";
import { ParametrosService } from "src/app/services/parametros.service";
import { RouterService } from "src/app/services/router.service";
import { SweetAlertService } from "src/app/services/sweet-alert.service";
import {
    getDocumentPatternMessage,
    numeroDocumentoPorTipoDocValidator,
} from "src/app/shared/utils/form-validators.util";
import { ReCaptchaV3Service } from "ng-recaptcha-2";
import { AnalyticsTagService } from "src/app/services/analytics-tag.service";
import {
    AuthFlowOrigen,
    getAuthFlowBgDesktop,
    getAuthFlowBgMobile,
    getAuthFlowOrigen,
} from "src/app/core/auth-flow-origen.storage";
declare var $: any;

const mensajeEnvioCorreo = 'PAR-108';
@Component({
    selector: 'activar-usuario',
    templateUrl: './activar-usuario.component.html',
    styleUrls: ['./activar-usuario.component.scss'],
    standalone: false
})
export class ActivarUsuarioComponent implements OnInit {
    validarForm: UntypedFormGroup;
    isRecordar: boolean = false;
    isDesbloquear: boolean = false;
    titulo: string = 'Activar usuario';
    mensajeEnvioCorreo: string;
    documentos: any[] = [];
    validarCorrreo = '^[a-z0-9._%+-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,4}$';
    captchaToken: string | null = null;
    captchaFailCount = 0;
    isBlockedCaptcha = false;
    /** Origen visual: micro | if (imagen de fondo del login correspondiente). */
    authOrigen: AuthFlowOrigen = 'micro';
    bgDesktop = getAuthFlowBgDesktop('micro');
    bgMobile = getAuthFlowBgMobile('micro');
    private captchaSubmitting = false;

    constructor(
        private _parametro: ParametrosService,
        private _router: RouterService,
        private router: Router,
        private _sweetAlert: SweetAlertService,
        private _bancoldexService: BancoldexService,
        private formBuilder: UntypedFormBuilder,
        private _verificacion: VerificacionService,
        private recaptchaV3Service: ReCaptchaV3Service,
        private _analyticsTag: AnalyticsTagService
    ) {
        window.scroll(0, 0);
        this.getMensajeEnvioCorreo();
        this.isRecordar = this.router.url === '/recordar' ? true : false;
        this.isDesbloquear = this.router.url === '/desbloquear' ? true : false;
        if (this.isRecordar == true) {
            this.titulo = 'Recordar contraseña';
        } else if (this.isDesbloquear == true) {
            this.titulo = 'Desbloquear usuario';
        }
        try {
            if (!this.isDesbloquear) {
                sessionStorage.removeItem('verificacion-desbloqueo');
            }
        } catch {
            // ignore
        }
        this.validarForm = this.formBuilder.group({
            opcion: [''],
            correoElectronico: [''],
            idTipoDocumento: [''],
            numeroDocumento: ['']
        });
        this.authOrigen = getAuthFlowOrigen();
        this.bgDesktop = getAuthFlowBgDesktop(this.authOrigen);
        this.bgMobile = getAuthFlowBgMobile(this.authOrigen);
    }

    ngOnInit() {
        const blockTime = localStorage.getItem('captchaBlock');
        if (blockTime) {
            const currentTime = Date.now();
            const unblockTime = parseInt(blockTime, 10);
            if (currentTime < unblockTime) {
                this.isBlockedCaptcha = true;
                const remainingTime = unblockTime - currentTime;
                setTimeout(() => {
                    this.isBlockedCaptcha = false;
                    this.captchaFailCount = 0;
                    this.clearCaptchaToken();
                    localStorage.removeItem('captchaBlock');
                }, remainingTime);
            } else {
                this.isBlockedCaptcha = false;
                localStorage.removeItem('captchaBlock');
            }
        }
        localStorage.removeItem('activate');
        if (!this.isDesbloquear) {
            this.setearValidadoresForm('correoElectronico', [
                Validators.required,
                Validators.pattern(this.validarCorrreo)
            ]);
        } else {
            this.setearValidadoresForm('opcion', [
                Validators.required
            ]);
            this.getDocumentos();
        }
    }

    private getCaptchaAction(): string {
        if (this.isRecordar) {
            return 'recordar';
        }
        if (this.isDesbloquear) {
            return 'desbloquear';
        }
        return 'activar_usuario';
    }

    verificarUsuario() {
        if (this.isBlockedCaptcha) {
            this._sweetAlert.errorModal("Demasiados intentos", true,
                "Tu acceso ha sido temporalmente bloqueado, por seguridad, debido a múltiples intentos incorrectos. Inténtalo nuevamente en 2 minutos.");
            return;
        }
        let body = {
            correoElectronico: this.validarForm.get('correoElectronico')?.value,
            captchaToken: this.captchaToken
        };

        if (this.isRecordar) {
            this._parametro.sendMailRecordar(body).subscribe((data: any) => {
                this.captchaFailCount++;
                if (data.exitoso == "true" || data.exitoso == true) {
                    this._sweetAlert.infoModal(data.correoOculto + ' enviado exitosamente', false, this.mensajeEnvioCorreo).then((result) => {
                        if (result.isConfirmed) {
                            this.captchaFailCount = 0;
                            this.router.navigateByUrl('/home');
                        }
                    });
                } else if ((data.exitoso == "false" || data.exitoso == false) && data.error) {
                    this._sweetAlert.errorModal("¡Error!", true, data.error);
                } else {
                    this._sweetAlert.infoModal(data.correoOculto + ' enviado exitosamente', false, this.mensajeEnvioCorreo).then((result) => {
                        if (result.isConfirmed) {
                            this.captchaFailCount = 0;
                            this.router.navigateByUrl('/home');
                        }
                    });
                }
                this.afterCaptchaAttempt();
            });
        } else if (this.isDesbloquear) {
            const rawNumero = this.validarForm.get('numeroDocumento')?.value;
            const numeroDocumento =
                rawNumero != null && String(rawNumero).trim() !== ''
                    ? String(rawNumero).trim()
                    : null;
            let json = {
                idTipoDocumento: this.validarForm.get('idTipoDocumento')?.value ? +this.validarForm.get('idTipoDocumento').value : null,
                numeroDocumento,
                correoElectronico: this.validarForm.get('correoElectronico')?.value ? this.validarForm.get('correoElectronico').value : null,
                captchaToken: this.captchaToken
            };

            this._parametro.desbloquearUsuario(json).subscribe((data: any) => {
                this.captchaFailCount++;
                if (data.exitoso == true) {
                    this.captchaFailCount = 0;
                    const unlockParams = {
                        token: data.token,
                        idUsuario: data.idUsuario,
                        isDesbloquear: true,
                        email: data.correoElectronico,
                        captchaToken: json.captchaToken
                    };
                    this._verificacion.saveParameters(unlockParams);
                    try {
                        sessionStorage.setItem(
                            'verificacion-desbloqueo',
                            JSON.stringify(unlockParams)
                        );
                    } catch {
                        // ignore
                    }
                    this.router.navigateByUrl('/verificacion');
                } else if (data.exitoso == false && data.error) {
                    this._sweetAlert.errorModal("¡Error!", true, data.error);
                } else if (this.validarForm.get('opcion')?.value == 1) {
                    this._sweetAlert.errorModal("¡Error!", true, "No hemos podido validar la información ingresada. Ingresa nuevamente el correo electrónico con el que te registraste en la plataforma. Si el correo electrónico no corresponde, comunícate al número 018000180710 y/o al correo electrónico contactenos@bancoldex.com");
                } else if (this.validarForm.get('opcion')?.value == 2) {
                    this._sweetAlert.errorModal("¡Error!", true, "No hemos podido validar la información ingresada. Ingresa nuevamente el número de documento con el que te registraste en la plataforma. Si el número de documento no corresponde, comunícate al número 018000180710 y/o al correo electrónico contactenos@bancoldex.com");
                }
                this.afterCaptchaAttempt();
            });
        } else {
            this._parametro.verificarCorreo(body).subscribe((data: any) => {
                this.captchaFailCount++;
                if (data.exitoso == "true" || data.exitoso == true || data.exitoso == "false" || data.exitoso == false) {
                    this._sweetAlert.errorModal("¡Error!", true, data.error);
                } else {
                    this.captchaFailCount = 0;
                    localStorage.setItem('activate', JSON.stringify({
                        email: this.validarForm.get('correoElectronico')?.value,
                        user: data.Usuario.nombreCompleto
                    }));
                    this.router.navigateByUrl('/establecer-password');
                }
                this.afterCaptchaAttempt();
            });
        }
    }

    private afterCaptchaAttempt(): void {
        if (this.captchaFailCount > 3) {
            this.blockCaptcha();
        } else {
            this.clearCaptchaToken();
        }
    }

    back() {
        this._analyticsTag.trackCtaClick({
            ctaLabel: 'Volver',
            ctaSection: this.trackingSeccion,
            ctaComponent: 'activar-usuario',
            ctaElementId: `btn-${this.trackingSeccion}-volver`,
            hu: '8337',
        });
        this._router.goBack();
    }

    /** `activar-usuario` sirve /activar-usuario, /recordar y /desbloquear con un solo componente. */
    private get trackingSeccion(): string {
        if (this.isRecordar) {
            return 'recordar-contrasena';
        }
        if (this.isDesbloquear) {
            return 'desbloquear-usuario';
        }
        return 'activar-usuario';
    }

    getMensajeEnvioCorreo() {
        var json = {
            idParametro: mensajeEnvioCorreo,
            nombre: null,
            isParFuncional: true,
            pagina: 1,
        };
        this._bancoldexService.getFilterParametro(json).subscribe(
            (response) => {
                var respuesta = response['data'];
                this.mensajeEnvioCorreo = respuesta[0].valorParametro;
            },
            (error) => {
                this._sweetAlert.errorModal("¡Error!", true, error.error);
            }
        );
    }

    getDocumentos() {
        this._parametro.getTipoDocumentos().subscribe((data: any) => {
            this.documentos = data.filter(
                (documento) =>
                    documento.personaJuridica == 0 &&
                    documento.idTipoDocIdentidad != 4 &&
                    documento.idTipoDocIdentidad != 6
            );
        });
    }

    validateForm() {
        if (!this.validarForm.valid) {
            this.validarForm.markAllAsTouched();
            return;
        }
        if (this.captchaSubmitting) {
            return;
        }
        this._analyticsTag.trackCtaClick({
            ctaLabel: 'Buscar cliente',
            ctaSection: this.trackingSeccion,
            ctaComponent: 'activar-usuario',
            ctaElementId: `btn-${this.trackingSeccion}-buscar`,
            hu: '8337',
        });
        this.captchaSubmitting = true;
        this.recaptchaV3Service.execute(this.getCaptchaAction()).subscribe({
            next: (token) => {
                this.captchaToken = token;
                this.captchaSubmitting = false;
                this.verificarUsuario();
            },
            error: () => {
                this.captchaSubmitting = false;
                this._sweetAlert.errorModal(
                    '¡Error!',
                    true,
                    'No se pudo validar el captcha. Inténtalo de nuevo.'
                );
            },
        });
    }

    validarOpcion(opcion: number) {
        if (opcion === 1) {
            this.setearValidadoresForm('correoElectronico', [
                Validators.required,
                Validators.pattern(this.validarCorrreo)
            ]);
            this.setearValidadoresForm('idTipoDocumento', null);
            this.setearValidadoresForm('numeroDocumento', null);
            this.validarForm.get('idTipoDocumento').setValue('');
            this.validarForm.get('numeroDocumento').setValue('');
        } else if (opcion === 2) {
            this.setearValidadoresForm('correoElectronico', null);
            this.validarForm.get('correoElectronico').setValue('');
            this.setearValidadoresForm('idTipoDocumento', [
                Validators.required
            ]);
            this.setearValidadoresForm('numeroDocumento', [
                Validators.required,
                Validators.maxLength(15),
                numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocumento'),
            ]);
        }
    }

    setearValidadoresForm(nombreCampo: string, validadores: any) {
        this.validarForm.controls[nombreCampo].setValidators(validadores);
        this.validarForm.controls[nombreCampo].updateValueAndValidity();
    }

    validarSelect() {
        this.validarForm.get('numeroDocumento').setValue('');
        this.validarForm.get('numeroDocumento')?.updateValueAndValidity();
    }

    validateField(key: string) {
        return (
            (this.validarForm.get(key).dirty || this.validarForm.get(key)?.touched) &&
            this.validarForm.get(key)?.invalid
        );
    }

    get mensajeErrorNumeroDocumento(): string {
        return getDocumentPatternMessage(this.validarForm.get('numeroDocumento'));
    }

    onEmailInput(event: Event): void {
        const target = event.target as HTMLInputElement;
        this.validarForm
            .get('correoElectronico')
            ?.setValue((target.value || '').toLowerCase(), { emitEvent: false });
    }

    clearCaptchaToken() {
        this.captchaToken = null;
    }

    blockCaptcha() {
        const block = Date.now() + 2 * 60 * 1000;
        localStorage.setItem('captchaBlock', block.toString());
        this.isBlockedCaptcha = true;
        setTimeout(() => {
            this.isBlockedCaptcha = false;
            this.captchaFailCount = 0;
            this.clearCaptchaToken();
            localStorage.removeItem('captchaBlock');
        }, 2 * 60 * 1000);
    }
}
